export function throttle(
  func: Function,
  delay = 300
) {
  let timer: ReturnType<typeof setTimeout> | undefined;

  return (...args: any[]) => {
    if (timer) return;

    timer = setTimeout(() => {
      func(...args);
      timer = undefined;
    }, delay);
  };
}